// Vollbildseite für Nutzer ohne Zwei-Faktor, wenn die Organisation es verlangt (Einstellungen › Sicherheit › „für alle verlangen“).
// Der AuthProvider zeigt sie anstelle der App, bis Zwei-Faktor eingerichtet ist; die Server-Wege dafür bleiben offen.
import { useAuth } from "../auth/AuthContext";
import { Logo } from "../components/Icon";
import { T8C } from "./texte";
import { ZweiFaktorEinrichten } from "./ZweiFaktorEinrichten";
import "../pages/einstellungen/nutzer.css";

export function ZweiFaktorPflicht() {
  const { abmelden, neuLaden } = useAuth();
  return (
    <div className="nv-pflicht">
      <div className="nv-pflicht__karte">
        <Logo groesse={28} />
        <h1>{T8C.pflicht.titel}</h1>
        <p className="seite__text">{T8C.pflicht.text}</p>
        <ZweiFaktorEinrichten onFertig={() => void neuLaden()} />
        <div>
          <button type="button" className="knopf knopf--leise knopf--klein" onClick={() => void abmelden()}>
            {T8C.pflicht.abmelden}
          </button>
        </div>
      </div>
    </div>
  );
}
